import React from 'react';

function Banner({ bannerImage, title, description }) {
  return (
    <div
      style={{
        backgroundImage: `url(${bannerImage})`,
      }}
      className="rooms__banner"
    >
      <div className="rooms__banner-content">
        <h1 className="rooms__banner-title">{title}</h1>
        <p className="rooms__banner-description">
          {description}
        </p>
      </div>
    </div>
  );
}

export default Banner;
